import {
  Box,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Bay
        </InputLabel>
        <TextField
          variant="outlined"
          name="bay"
          value={filterData.bay}
          onChange={handleChangeFilter("bay")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Order Live
        </InputLabel>
        <FormControl fullWidth>
          <Select
            value={filterData.isLive}
            onChange={(e) => handleChangeFilter("isLive")(e)}
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleFilter();
            }}
          >
            <MenuItem value={"Yes"}>Yes</MenuItem>
            <MenuItem value={"No"}>No</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{ mr: 1, color: "#7152F3" }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            sx={{ backgroundColor: "#7152F3" }}
          >
            Filter{" "}
            <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
